<template>
  <div class="fab-container">
    <transition name="fab-menu">
      <div v-if="menuOpen" class="fab-menu">
        <b-button
          v-for="shortcut in selectedShortcuts"
          :key="shortcut.id"
          variant="info"
          pill
          class="fab-item px-8 py-3 my-2"
          @click="navigateToShortcut(shortcut.id)"
        >
          {{ shortcut.shortcutLabel }}
        </b-button>
      </div>
    </transition>

    <b-button
      variant="primary"
      size="lg"
      class="px-8 py-4"
      pill
      @click="toggleMenu"
    >
      Atalhos
    </b-button>
  </div>
</template>

<script>
import {
  flattenDashboardShortcutGroups,
  getAvailableDashboardShortcutGroups,
  getDashboardShortcutLocation,
  getSelectedDashboardShortcutIds,
} from "../dashboardShortcuts";

export default {
  data() {
    return {
      menuOpen: false,
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser || {};
    },
    availableShortcuts() {
      return flattenDashboardShortcutGroups(
        getAvailableDashboardShortcutGroups(this.currentUser?.recursos || [])
      );
    },
    selectedShortcuts() {
      const selectedIds = getSelectedDashboardShortcutIds(
        this.currentUser?.dashboard_shortcuts,
        this.availableShortcuts
      );
      const shortcutsById = new Map(
        this.availableShortcuts.map((shortcut) => [shortcut.id, shortcut])
      );

      return selectedIds.map((id) => shortcutsById.get(id)).filter(Boolean);
    },
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    navigateToShortcut(shortcutId) {
      this.menuOpen = false;
      this.$router.push(getDashboardShortcutLocation(shortcutId));
    },
  },
};
</script>

<style scoped>
.fab-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  text-align: right;
}

.fab-menu {
  display: flex;
  flex-direction: column;
  max-height: 70vh;
  margin-bottom: 10px;
  align-items: flex-end;
  overflow-y: auto;
}

.fab-item {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}

.fab-menu-enter-active,
.fab-menu-leave-active {
  transition: all 0.3s;
}
.fab-menu-enter,
.fab-menu-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
